function ProductDetails(){

}

export default ProductDetails;